import { z } from 'zod';
import { dateTimeSchema, queryBoolean, requiredText, versionField } from './fields';
import { idSchema } from './ids';

/**
 * Notes of a project (FR-PRJ-026…032) or a customer (FR-CUST-017…019) — one entity, one API,
 * one UI component. PMAI's "Visible" flag became archiving (decision 2026-10-12).
 */
export const noteInputSchema = z.object({
  content: requiredText(20_000, 'Piezīmes saturs ir obligāts'),
  /** Defaults to "now" when omitted (FR-CUST-017). */
  noteAt: dateTimeSchema.optional(),
  important: z.boolean().default(false),
});
export type NoteInput = z.input<typeof noteInputSchema>;

export const noteUpdateSchema = noteInputSchema.extend(versionField);

export const noteArchiveSchema = z.object({ archived: z.boolean() });

export const noteListQuerySchema = z.object({ includeArchived: queryBoolean });

export const noteSchema = z.object({
  id: idSchema,
  content: z.string(),
  noteAt: z.string(),
  important: z.boolean(),
  archivedAt: z.string().nullable(),
  version: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Note = z.infer<typeof noteSchema>;
